// extracted by mini-css-extract-plugin
export var chevron = "_jg-4";
export var chevronExpanded = "_jg-5";
export var row = "_jg-0";
export var rowBody = "_jg-6";
export var rowDescription = "_jg-7";
export var rowHeader = "_jg-1";
export var rowTitle = "_jg-2";
export var rowTitleComplete = "_jg-3";